module.exports = __webpack_public_path__ + "static/result_yeosu-8e412d08faf08cef2cbc77f148e061ff.png";